import styled from 'styled-components';

type HeaderProps = {
  textAlign?: string;
  light?: boolean;
};

const Header = styled.h2<HeaderProps>`
  font-style: normal;
  text-align: ${({ textAlign }) => textAlign || 'center'};
  margin: 4rem 0 2.8rem 0;
  font-weight: 600;
  font-size: 2.8rem;
  color: ${({ light, theme }) => (light ? '#ffffff' : theme.COLORS.PRIMARY)};

  @media ${({ theme }) => theme.DEVICE.LG} {
    font-size: 3.6rem;
    margin: 0 0 6rem 0;
    padding-top: 2rem;
  }
`;

export default Header;
